<template>
    <div>
        <div class="dev-building-actions">
          <a :href="`/developer/${projectId}/add-project-step2?type=apartment`" class="general-btn positive-btn" v-if="canManage">
            <span> Adauga Model </span>
          </a>
          <a href="javascript:void(0)" @click="openAddBuildingModal(projectId)" class="general-btn positive-btn" v-if="canManage">
              <span> Adauga Bloc </span>
          </a>
        </div>
        <div class="pdetail-group-filters">
          <div class="project-dropdown">
            <div class="project-dropdown__button" @click="flatDropdown = !flatDropdown">
              <i class="fad fa-city"></i>
              <div class="project-dropdown__title">Alege bloc</div>
              <i class="fas fa-caret-down" v-if="!flatDropdown"></i>
              <i class="fas fa-caret-up" v-else></i>
            </div>
            <div class="project-dropdown__counter" v-if="buildingsFilter.length > 0">
              {{buildingsFilter.length}}
            </div>
            <div class="project-dropdown__menu" v-if="flatDropdown">
              <div class="project-dropdown__item" v-for="(building, key) in buildings" :key="key">
                <input type="checkbox"
                  :id="`modelApartmentPanelblockId${building.id}`"
                  :value="building"
                  class="project-dropdown__input"
                  v-model="buildingsFilter"
                  @change="setBuildingsFilter(building, `modelCommercialPanelblockId${building.id}`)">
                <label :for="`modelApartmentPanelblockId${building.id}`" class="project-dropdown__label">
                  <span>Bloc {{ building.name }}</span>
                  <span>{{ building.items_count }}</span>
                </label>
              </div>
              <div class="project-dropdown__item project-dropdown__item--empty" @click="flatDropdown = false" v-if="buildings.length == 0">
                <label class="project-dropdown__label">
                  <span>
                    Nu exista filtre disponibile
                  </span>
                </label>
              </div>
              <div class="project-dropdown__close" @click="flatDropdown = false">
                <i class="fas fa-times"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="project-grid-container">
          <div class="project-card" v-for="(model, key) in displayModels" :key="key">
            <div class="project-card__name">
              <i class="fad fa-layer-group"></i>
              <a :href="`/developer/project/${projectId}/model/${model.id}/details?client=${urlParams.client}`" v-if="urlParams && urlParams.client">
                Tip {{ model.model_type }}
              </a>
              <a :href="`/developer/project/${projectId}/model/${model.id}/details`" v-else>
                Tip {{ model.model_type }}
              </a>
            </div>
            <div class="project-card__info">
              <span>Suprafata Totala</span>
              <span>{{ model.useful_surface }} (m²)</span>
            </div>
            <div class="project-card__info" v-if="model.terrace_surface">
              <span>Suprafata Balcon</span>
              <span>{{ model.terrace_surface }} (m²)</span>
            </div>
            <div class="project-card__info">
              <span>Pret de la</span>
              <span>{{ formatPrice(model.min_price) }}</span>
            </div>
            <div class="project-card__info">
              <span>Pret cu credit de la</span>
              <span v-if="model.min_credit_price"> {{ formatPrice(model.min_credit_price) }}</span>
              <span v-else>&nbsp;</span>
            </div>
            <div class="project-card__info">
              <span>Disponibilitate</span>
              <span>{{ model.items_count }}</span>
            </div>
            <div class="project-card__published" v-if="model.publish">
              Publicat
            </div>
            <div class="project-card__published project-card__published--not" v-else>
              Nepublicat
            </div>
            <div class="project-card__buttons">
              <a :href="`/developer/${projectId}/${model.id}/add-project-step3`" class="project-card__button" data-toggle="tooltip" data-placement="top" title="Adauga Disponibilitati">
                <i class="fas fa-building"></i>
              </a>
              <a :href="`/developer/${model.project_id}/model/${model.id}/edit`" class="project-card__button" data-toggle="tooltip" data-placement="top" title="Modifica Model">
                <i class="fas fa-edit"></i>
              </a>
              <a href="javascript:void(0)" v-if="model.total_items == 0" @click="deleteModel(model.id)" class="project-card__button project-card__button--delete"  data-toggle="tooltip" data-placement="top" title="Sterge Model">
                <i class="fas fa-trash"></i>
              </a>
              <a href="javascript:void(0)" class="project-card__button project-card__button--delete" @click="alertDelete()" data-toggle="tooltip" data-placement="top" title="Sterge Model" v-else>
                <i class="fad fa-trash-alt"></i>
              </a>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "DeveloperListCommercialModels",
    props: ['projectId','canManage'],
    components: {
      // editor
    },
    data() {
      return {
        roomsCount: [],
        buildings: [],
        buildingsFilter: [],
        roomsCountFilter: [],
        models: [],
        urlParams: null,
        flatDropdown: false
      }
    },
    computed: {
      displayModels(){
        let output = []
        for(let i in this.models){
          if(this.passFilter(this.models[i])){
            output.push(this.models[i])
          }
        }
        return output
      }
    },
    async mounted() {
      this.urlParams = window.getAllUrlParams();
      await this.getBuildings()
      await this.getModels()
    },
    methods: {
      getBuildings() {
        let vm = this
        window.axios.get(`/ajax/get-buildings-by-model-type/${this.projectId}/commercial`)
          .then(function (resp) {
            vm.buildings = resp.data.data
          })
          .catch(function () {
            // window.showError(err)
          });
      },
      getModels() {
        let vm = this
        window.axios.get(`/ajax/developer/get-models/${this.projectId}/commercial`)
          .then(function (resp) {
            vm.models = resp.data.data
          })
          .catch(function () {
            // window.showError(err)
          });
      },
      setBuildingsFilter(building, elementId) {
        let el = document.getElementById(elementId)
        let item = this.buildingsFilter.find(b => b.id === building.id)
        if(el.checked) {
          if(!item) {
            this.buildingsFilter.push(building)
          }
        } else {
          if(item) {
            this.buildingsFilter.splice(this.buildingsFilter.lastIndexOf(item), 1)
          }
        }
      },
      passFilter(model) {
        if(this.buildingsFilter.length > 0){
          let includes = false
          for(let i in this.buildingsFilter) {
            if(model.buildings.find(b => b.id === this.buildingsFilter[i].id)){
              includes = true
              break
            }
          }
          if(!includes) return false
        }

        return true
      }
    }
  }
</script>
